<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col md="10" align="center" justify="center">
        <div width="650px" style="padding: 10px">
          <!-- HEADER SECTION -->

          <v-row
            class="justify-center align-center text-center"
            style="max-width: 650px"
          >
            <v-col class="text-left">
              <img :src="client_logo" style="width: 125%" />
            </v-col>
            <v-col md="8">
              <h3 style="">Verify Your Dependents for Audit</h3>
            </v-col>
            <v-col class="text-right"> </v-col>
          </v-row>

          <br />

          <!-- CONFIRM IDENTITY SECTION -->

          <div class="flex-wrapper" style="max-width: 450px; margin: 20px auto">
            <div class="flex-size">
              <tr>
                <td>
                  <p style="font-weight: bold; padding-bottom: 20px">
                    Confirm your Identity
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <v-text-field
                    v-model="Locator"
                    dense
                    outlined
                    hide-details
                    label="Record Locator"
                    style="padding-bottom: 10px"
                  ></v-text-field>
                </td>
                <td style="padding-left: 5px; vertical-align: middle">
                  <v-tooltip max-width="400" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-img
                        style="cursor: pointer"
                        height="20px"
                        width="20px"
                        :src="require('@/assets/images/info16.png')"
                        v-bind="attrs"
                        v-on="on"
                      >
                      </v-img>
                    </template>
                    <span
                      v-html="
                        'Your personal Record Locator Code was emailed to you. Please check our email and copy the Record Locator here.'
                      "
                    ></span>
                  </v-tooltip>
                </td>
              </tr>
              <tr>
                <td>
                  <v-text-field
                    v-model="Zip"
                    dense
                    outlined
                    hide-details
                    label="Home Zip Code"
                  ></v-text-field>
                </td>
                <td style="padding-left: 5px; vertical-align: middle">
                  <v-tooltip max-width="400" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-img
                        style="cursor: pointer"
                        height="20px"
                        width="20px"
                        :src="require('@/assets/images/info16.png')"
                        v-bind="attrs"
                        v-on="on"
                      >
                      </v-img>
                    </template>
                    <span
                      v-html="
                        'Home zip code is the 5-digit zip code on record with your employer. If you enter your zip code and your Record Locator and are unable to verify your identity, please call our client support center 8:30 AM - 5:00 PM Eastern Time; except during Federal holidays. Call us Toll-Free at 1 (800) 945-5513 or email us at Support@BASusa.com.'
                      "
                    ></span>
                  </v-tooltip>
                </td>
              </tr>

              <!-- <input
                style="width: 90%; padding: 5px; margin: 5px"
                type="text"
                id="Locator"
                value="Record Locator from Email"
              /> -->
              <!--   <input
                style="width: 90%; padding: 5px; margin: 5px"
                type="text"
                id="HomeZip"
                value="Home Zip Code"
              /> -->
            </div>
          </div>

          <div
            id="recaptcha"
            class="g-recaptcha"
            :data-sitekey="rcapt_sig_key"
            data-callback="onVerify"
          ></div>

          <div style="max-width: 300px; margin: 20px auto; text-align: center">
            <v-btn
              color="primary"
              class="text-none"
              style="
                background-color: #005c84;
                color: #fff;
                border: 0px;
                padding: 10px 15px;
                font-size: 18px;
                margin-top: 15px;
                width: 100%;
                border-radius: 30px;
              "
              @click="clickOK()"
            >
              Verify
            </v-btn>
          </div>

          <div class="flex-wrapper section-wrapper">
            <div class="flex-size" style="text-align: left">
              <p>
                <a href="#" @click="ShowPrivacyStatement()"
                  >Privacy Statement</a
                >
              </p>
              <div id="google_translate_element"></div>
            </div>
            <div class="flex-size" style="text-align: right">
              <p>
                <a href="#" @click="LookupLocator"
                  >Get Your Record Locator Code</a
                >
              </p>
            </div>
          </div>
        </div>
      </v-col></v-row
    >

    <v-dialog v-model="dgLookupLocator" persistent width="500">
      <v-card>
        <v-toolbar class="headline grey lighten-2" height="40px">
          <v-card-title> Locator Code </v-card-title>
        </v-toolbar>

        <v-card-text>
          <br />

          <v-text-field
            v-model="email"
            dense
            outlined
            hide-details
            label="Email"
            style="padding-bottom: 10px"
          ></v-text-field>
          <v-text-field
            v-model="zipcode"
            dense
            outlined
            hide-details
            label="Home Zip Code"
          ></v-text-field>
          <div style="width: 100%; text-align: center; margin-top: 10px">
            <div
              style="display: inline-block"
              id="recaptcha2"
              class="g-recaptcha"
              :data-sitekey="rcapt_sig_key"
              data-callback="onVerify2"
            ></div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-none"
            style="border-radius: 10px !important"
            @click="Cancel_Clicked"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            class="text-none"
            style="border-radius: 10px !important"
            @click="RequestLocator"
          >
            Request
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- display privacy statement -->
    <v-dialog v-model="dgPrivacy" persistent width="800px">
      <v-card class="pa-0 ma-0 overflow-hidden" height="100%">
        <v-toolbar height="40" headline grey lighten-2>
          <v-toolbar-title>ONLINE PRIVACY STATEMENT</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- <div
            style="
              height: 30px;
              line-height: 30px;
              width: 30px;
              font-family: 'Gill Sans', sans-serif;
              font-size: 18pt;
              font-weight: bold;
              border-radius: 50%;
              background-color: transparent;
              color: black;
              text-align: center;
              cursor: pointer;
            "
            @click="dgPrivacy = false"
          >
            x
          </div> -->
          <v-btn
            icon
            color="black"
            size="x-small"
            elevation="0"
            @click="dgPrivacy = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <div style="width: 100%; height: 680px">
          <iframe
            src="/privacystatement.html"
            style="width: 100%; height: 670px; border: none; display: block"
            scrolling="auto"
            allowfullscreen
            sandbox="allow-same-origin allow-scripts allow-popups"
          >
          </iframe>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dgEmailSent" persistent width="500">
      <v-card>
        <v-toolbar class="headline grey lighten-2" height="40px">
          <v-card-title>Notification</v-card-title>
        </v-toolbar>
        <v-card-text>
          <br />
          <p style="text-align: center">{{ msgText }}</p>
          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-none"
            style="border-radius: 10px !important"
            @click="
              dgEmailSent = false;
              msgText = '';
            "
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "App",
  components: {},
  data: () => ({
    msgText: "",
    dgEmailSent: false,
    Locator: null,
    Zip: null,
    dgLookupLocator: false,
    rcapt_sig_key: "6LexPT0qAAAAAAMT7z4ekY98v2G3-KiOFEdhokFA",
    rcapt_token2: null,
    recaptcha_2: false,
    email: null,
    zipcode: null,
    LocatorWidge: null,
    locatorlookup: 0,
    dgPrivacy: false,
  }),

  created() {
    this.trackPageViews();
    this.trackClickStream();
  },
  mounted() {
    window.onVerify = this.onVerify;

    let recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute(
      "src",
      "https://www.google.com/recaptcha/api.js"
    );
    document.head.appendChild(recaptchaScript);
    this.rcapt_token = null;
    this.rcapt_token2 = null;
  },
  methods: {
    AddSessionInfo: async function () {
      const userAgent = navigator.userAgent;
      let browserName = "Unknown Browser";
      let version = "Unknown Version";

      // Chrome
      if (userAgent.includes("Chrome")) {
        browserName = "Chrome";
        version = userAgent.match(/Chrome\/(\d+\.\d+\.\d+\.\d+)/)[1];
      }
      // Firefox
      else if (userAgent.includes("Firefox")) {
        browserName = "Firefox";
        version = userAgent.match(/Firefox\/(\d+\.\d+)/)[1];
      }
      // Safari
      else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
        browserName = "Safari";
        version = userAgent.match(/Version\/(\d+\.\d+\.\d+)/)[1];
      }
      // Edge
      else if (userAgent.includes("Edg")) {
        browserName = "Edge";
        version = userAgent.match(/Edg\/(\d+\.\d+\.\d+\.\d+)/)[1];
      }
      // Internet Explorer
      else if (userAgent.includes("MSIE") || userAgent.includes("Trident")) {
        browserName = "Internet Explorer";
        const ieVersionMatch = userAgent.match(/(MSIE\s|rv:)(\d+\.\d+)/);
        version = ieVersionMatch ? ieVersionMatch[2] : "Unknown Version";
      }

      //operating system
      let os = "Unknown OS";

      if (userAgent.includes("Win")) {
        os = "Windows";
      } else if (userAgent.includes("Mac")) {
        os = "macOS";
      } else if (userAgent.includes("X11") || userAgent.includes("Linux")) {
        os = "Linux";
      } else if (userAgent.includes("Android")) {
        os = "Android";
      } else if (userAgent.includes("like Mac")) {
        os = "iOS";
      }

      // Device Type
      let deviceType = "Unknown";
      if (/Mobile|Android|iPhone|iPad|iPod/i.test(userAgent)) {
        if (/iPad/i.test(userAgent)) {
          deviceType = "Tablet"; // iPad is considered a tablet
        }
        deviceType = "Mobile"; // All other mobile devices
      } else {
        deviceType = "Desktop"; // Any other device
      }

      // Screen Resolution
      const width = window.screen.width;
      const height = window.screen.height;
      let screenResolution = width + "x" + height;

      //language preferences
      const primaryLanguage = navigator.language || navigator.userLanguage;

      // Get the referrer URL
      const referrerURL = document.referrer;

      //client time zone
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      //Geolocation
      var GeoLocation = await this.getGeolocation();

      // get connection type
      let connectionType = "Unknown connection type";

      if ("connection" in navigator) {
        const connection = navigator.connection;

        // Determine the effective connection type
        const effectiveType =
          connection.effectiveType || "Unknown connection type";

        // Determine the connection type

        switch (effectiveType) {
          case "wifi":
            connectionType = "WiFi";
            break;
          case "ethernet":
            connectionType = "Ethernet";
            break;
          case "cellular":
            connectionType = "Cellular (Mobile)";
            break;
          case "slow-2g":
          case "2g":
            connectionType = "2G";
            break;
          case "3g":
            connectionType = "3G";
            break;
          case "4g":
            connectionType = "4G";
            break;
          default:
            connectionType = effectiveType; // Fallback to effectiveType
        }
      } else {
        connectionType = "Unknown connection type";
      }

      // Get pages view
      let pageView = "";
      const pageViews = localStorage.getItem("pageViews");
      // Check if pageViews is null and return appropriate message
      if (pageViews === null) {
        pageView = "No page views recorded.";
      } else {
        pageView = parseInt(pageViews); // Parse and return the count
      }

      //Click Stream Data
      //const clickStream = this.getClickStreamData();

      // IP
      let ipAddress = await this.getUserIP();
      var self = this;
      axios
        .post(self.methodUrl + "/depdoc/WebService.asmx/AddSessionInfo", {
          employee_number: self.employee_number,
          ip_address: ipAddress,
          user_agent_string: userAgent,
          browser_type: browserName,
          browser_version: version,
          operating_system: os,
          device_type: deviceType,
          screen_resolution: screenResolution,
          language_preferences: primaryLanguage,
          referrer_url: referrerURL,
          time_zone: timeZone,
          cookies: "",
          session_id: "",
          geolocation_data: GeoLocation,
          connection_type: connectionType,
          page_views: pageView,
          clickstream_data: "",
        })
        .then((r) => {
          self.session_record_id = r.data.d;
        })
        .catch(() => {});

      /* return {
        userAgent,
        browserName,
        version,
        os,
        deviceType,
        screenResolution,
        primaryLanguage,
        referrerURL,
        timeZone,
        GeoLocation,
        connectionType,
        pageView,
        clickStream,
        ipAddress,
      }; */
    },

    getGeolocation: async function () {
      var geo = "";
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            geo = "(Latitude, Longitude): (" + latitude + "," + longitude + ")";
          },
          () => {
            geo = "";
          },
          {
            enableHighAccuracy: true, // Use high accuracy if available
            timeout: 5000, // Timeout after 5 seconds
            maximumAge: 0, // Do not use cached position
          }
        );
      } else {
        geo = "Geolocation is not supported by this browser.";
      }

      return geo;
    },

    getUserIP: async function () {
      try {
        // Use a public API to get the user's IP address
        const response = await fetch("https://api.ipify.org?format=json");
        const data = await response.json();

        return data.ip; // Return the IP address
      } catch (error) {
        return null; // Return null in case of error
      }
    },

    getClickStreamData() {
      // Retrieve the clickstream data from localStorage
      const clickstreamData = localStorage.getItem("clickstream");

      // Check if data exists
      if (clickstreamData) {
        // Parse the JSON string into an array
        const clickDataArray = JSON.parse(clickstreamData);

        // Return the click data array
        return clickDataArray;
      } else {
        return [];
      }
    },

    trackClickStream() {
      // Initialize an array to hold click data
      let clickData = JSON.parse(localStorage.getItem("clickstream")) || [];

      // Event listener for clicks on the document
      document.addEventListener("click", (event) => {
        const clickInfo = {
          timestamp: new Date().toISOString(),
          element: event.target.tagName, // Get the tag name of the clicked element
          id: event.target.id, // Get the ID of the clicked element, if available
          classList: Array.from(event.target.classList), // Get classes as an array
          x: event.clientX, // Get X coordinate of the click
          y: event.clientY, // Get Y coordinate of the click
          url: window.location.href, // Current URL
        };

        // Add the click info to the click data array
        clickData.push(clickInfo);

        // Store the updated click data in localStorage
        localStorage.setItem("clickstream", JSON.stringify(clickData));
      });
    },

    trackPageViews() {
      // Check if the 'pageViews' key exists in localStorage
      let pageViews = localStorage.getItem("pageViews");

      // If it doesn't exist, initialize it to 0
      if (pageViews === null) {
        pageViews = 0;
      } else {
        // Parse the current value to an integer
        pageViews = parseInt(pageViews);
      }

      // Increment the page view count
      pageViews += 1;

      // Store the updated count back in localStorage
      localStorage.setItem("pageViews", pageViews);
    },

    ShowPrivacyStatement() {
      this.dgPrivacy = true;
    },

    async RequestLocator() {
      var self = this;

      if (
        self.rcapt_token2 != null &&
        self.rcapt_token2 != "" &&
        self.email != null &&
        self.email != "" &&
        self.zipcode != null &&
        self.zipcode != ""
      ) {
        await axios
          .post(self.methodUrl + "/depdoc/WebService.asmx/RequestLocator", {
            email: self.email,
            zip: self.zipcode,
          })
          .then((r) => {
            self.locatorlookup = r.data.d;
          })
          .catch(() => {
            self.locatorlookup = 0;
          });

        window.grecaptcha.reset(this.LocatorWidge);
        self.email = null;
        self.zipcode = null;
        self.rcapt_token2 = null;
        self.dgLookupLocator = false;
        if (self.locatorlookup == 1) {
          self.msgText = "Email has been sent with your locator code.";
          self.dgEmailSent = true;
        } else {
          self.msgText = "Employee Not Found";
          self.dgEmailSent = true;
        }
      }
    },

    Cancel_Clicked() {
      window.grecaptcha.reset(this.LocatorWidge);
      this.dgLookupLocator = false;
    },

    LookupLocator: async function () {
      this.dgLookupLocator = true;
      var self = this;

      if (document.getElementById("recaptcha2") == null) {
        setTimeout(async () => {
          window.onVerify2 = self.onVerify2;
          self.LocatorWidge = await window.grecaptcha.render(
            document.getElementById("recaptcha2"),
            {
              sitekey: self.rcapt_sig_key,
            }
          );
        }, 0);
      }
    },

    VerifyLogin: async function (doc_locator, zip) {
      var self = this;

      var re = 0;
      await axios
        .post(self.methodUrl + "/depdoc/WebService.asmx/VerifyLogin", {
          doc_locator: doc_locator,
          zip: zip,
        })
        .then((r) => {
          re = r.data.d;
        })
        .catch(() => {
          re = 0;
        });
      return re;
    },

    onVerify(token) {
      this.rcapt_token = token;
    },

    onVerify2(token) {
      this.rcapt_token2 = token;
    },

    /* clickOK: async function () {
      var self = this;
      var r = await self.VerifyLogin(self.Locator, self.Zip);
      if (r > 0) {
        self.employee_number = r;
        self.$router.push({ name: "dependentPage" });
      }
    }, */

    clickOK: async function () {
      var self = this;
      // self.$router.push({ name: "dependentPage" });

      var r = await self.VerifyLogin(self.Locator, self.Zip);
      if (r > 0 && self.rcapt_token != null && self.rcapt_token != "") {
        self.employee_number = r;
        self.AddSessionInfo();
        self.$router.push({ name: "dependentPage" });
      }

      //this.$refs.recaptcha.execute();
      // if (this.rcapt_token) this.$router.push({ name: "dependentPage" });
    },
  },

  computed: {
    methodUrl() {
      return "https://www.depcertify.com";
      // return "http://localhost/web_projects";
      /* if (
        location.href.toLowerCase().indexOf("bastest") > -1 ||
        location.href.toLowerCase().indexOf("myenroll") > -1
      )
        return "/web_projects";
      else if (location.href.toLowerCase().indexOf("depcertify") > -1)
        return "/depdoc";
      else return "http://localhost/web_projects"; */
    },

    client_logo() {
      return "./logo/0017797.jpg";
    },

    session_record_id: {
      get() {
        return this.$store.state.session_record_id;
      },
      set(newValue) {
        this.$store.state.session_record_id = newValue;
      },
    },

    rcapt_token: {
      get() {
        return this.$store.state.rcapt_token;
      },
      set(newValue) {
        this.$store.state.rcapt_token = newValue;
      },
    },

    employee_number: {
      get() {
        return this.$store.state.employee_number;
      },
      set(newValue) {
        this.$store.state.employee_number = newValue;
      },
    },
  },
};
</script>

<style scoped>
h1,
h2,
h3,
h4,
h5,
h6,
p,
li {
  font-family: "Open Sans", sans-serif;
  color: #565656;
  margin: 0px;
  padding: 0px;
}
ul,
ol,
li {
  font-family: "Open Sans", sans-serif;
  color: #565656;
}
h1 {
  font-size: 2em;
  font-weight: 700;
}
h2 {
  font-size: 1.5em;
  font-weight: 700;
}
h3 {
  font-size: 1.3em;
  font-weight: 700;
}
h4 {
  font-size: 1em;
  font-weight: 700;
}
h5 {
  font-size: 0.8em;
  font-weight: 700;
}
h6 {
  font-size: 0.7em;
  font-weight: 700;
}
p {
  font-size: 1em;
  font-weight: 500;
}
a {
  text-decoration: none;
  color: #22386e;
}
a:active {
  color: #22386e;
}

/**
* Dependent Audit Sign-in Framework styling
*
*
*/
.box-wrapper {
  max-width: 700px;
  margin: 0 auto;
  padding: 10px;
  border-radius: 3px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
}
.flex-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.flex-size {
  flex: 1;
}
.text-centeralign {
  text-align: center;
}
.section-wrapper {
  max-width: 650px;
  margin: 20px auto;
}
.input-style {
  width: 90%;
  padding: 10px;
  border: 1px solid #999999;
  border-radius: 3px;
}
.blue-btn-style {
  background-color: #005c84;
  color: #fff;
  border: 0px;
  padding: 10px 15px;
  font-size: 18px;
  margin-top: 15px;
  width: 90%;
  border-radius: 30px;
  transition: all 0.2s;
  cursor: pointer;
}
.orange-btn-style {
  background-color: #e27526;
  color: #fff;
  border: 0px;
  padding: 10px 15px;
  font-size: 18px;
  margin-top: 15px;
  width: 90%;
  border-radius: 30px;
  transition: all 0.2s;
  cursor: pointer;
}
.blue-btn-style:hover {
  background-color: #006794;
}
.orange-btn-style:hover {
  background-color: #e28326;
}

/* SMALL SCREEN SIZING */
@media screen and (max-width: 767px) {
  .flex-wrapper {
    flex-direction: column;
  }
}
</style>
